import * as React from "react";
import { cn } from "@racoon/ui";

/** Uppercase caption that opens each block of fields ("ЮРИДИЧЕСКИЕ ДАННЫЕ"). */
const SectionTitle: React.FC<{ children: React.ReactNode; action?: React.ReactNode }> = ({
  children,
  action,
}) => (
  <div className="flex w-full items-center justify-between">
    <p className="text-xs font-bold uppercase leading-4 text-icon-secondary">{children}</p>
    {action}
  </div>
);

/** A section: its caption, then its fields. */
export const Section: React.FC<{
  title: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
}> = ({ title, action, children }) => (
  <div className="flex w-full flex-col gap-4">
    <SectionTitle action={action}>{title}</SectionTitle>
    <div className="flex w-full flex-col gap-3">{children}</div>
  </div>
);

export const OnboardingField: React.FC<{
  label: React.ReactNode;
  required?: boolean;
  htmlFor?: string;
  /** Align the label to the top rather than the middle — for multi-line controls. */
  alignTop?: boolean;
  /** Narrower label column, for the steps whose labels are short. */
  labelWidth?: number;
  className?: string;
  children: React.ReactNode;
}> = ({ label, required, htmlFor, alignTop, labelWidth = 200, className, children }) => (
  <div
    className={cn(
      "flex w-full min-w-0 gap-4",
      alignTop ? "items-start" : "items-center",
      className,
    )}
  >
    <label
      htmlFor={htmlFor}
      style={{ width: labelWidth }}
      className={cn(
        "relative shrink-0 text-sm font-medium leading-4 tracking-[-0.2px] text-text-body",
        alignTop && "pt-2",
      )}
    >
      {required && <span className="absolute -left-2 top-0 text-text-error">*</span>}
      {label}
    </label>
    <div className="min-w-0 flex-1">{children}</div>
  </div>
);
